import React from "react";
import classNames from "classnames";

import { ReactComponent as SendIcon } from "@images/icons/send-icon.svg";
import Spinner from "@components/toolkit/Spinner/Spinner";

import "./SendButton.scss";

interface SendButtonProps {
  title?: string;
  submitting?: boolean;
  disabled?: boolean;
  active?: boolean;
  error?: boolean;
  className?: string;
  onClick?(): void;
}

const SendButton = ({ title, submitting, disabled, active, error, className, onClick }: SendButtonProps) => {
  const classes = classNames(`send-button`, { "send-button--active": active, "send-button--error": error }, className);

  return (
    <button title={title} disabled={disabled} onClick={onClick} className={classes}>
      {submitting && <Spinner sizePx={16} variant="white" className="send-button__spinner" />}
      {!submitting && <SendIcon />}
    </button>
  );
};

export default SendButton;
